interface Props<T> {
  array: T[];
  shouldExpand: boolean;
}

const limitArraySize = <T>(props: Props<T>): T[] => {
  const { array, shouldExpand } = props;
  return shouldExpand ? array.slice(0, 10) : array.slice(0, 5);
};

export default limitArraySize;
